<template>
  <div class="footers">
    <div class="wrapper">
      <div class="text-left">
        <div class="text-item aligntop">
          <dl class="title">{{ languageDataObj.aboutYedeer[language] }}</dl>
          <dl class="list">
            <dd class="item" title="+86 13156199890">
              {{ languageDataObj.phone[language] }}： +86 13156199890
            </dd>
            <dd class="item" title="besesun.translator@gmail.com">
              {{
                languageDataObj.facebook[language]
              }}：besesun.translator@gmail.com
            </dd>
            <dd class="item" title="yedeer@besesun.com">
              {{ languageDataObj.email[language] }}：yedeer@besesun.com
            </dd>
            <dd class="item" title="Yedeer2023">
              {{ languageDataObj.wechat[language] }}：Yedeer2023
            </dd>
          </dl>
        </div>
        <div class="text-item">
          <dl class="title">{{ languageDataObj.follow[language] }}</dl>
          <dl class="list">
            <a
              class="lo lo1"
              target="_blank"
              title="Facebook"
              href="https://www.facebook.com/profile.php?id=100082511291974"
            ></a>
            <a
              class="lo lo2"
              target="_blank"
              title="Twitter"
              href="https://twitter.com/YedeerB"
            ></a>
            <a
              class="lo lo3"
              target="_blank"
              title="whatsapp"
              href="https://api.whatsapp.com/send?phone=8615562457065"
            ></a>
          </dl>
        </div>
      </div>
      <div class="qrcode-right">
        <div class="qrcode" title="QR Code of Official Wechat Group">
          <img
            src="@/assets/images/douyin.jpg"
            class="imgs"
            title="抖音"
            alt="Twitter"
          />
          <p>抖音</p>
        </div>
        <div class="qrcode" title="QR Code of Official Wechat Group">
          <img
            src="@/assets/images/gongzhonghao.jpg"
            class="imgs"
            title="公众号"
            alt="Instagram"
            style="border: 1px solid #000"
          />
          <p>微信公众号</p>
        </div>
        <div class="qrcode" title="QR Code of Official Wechat Group">
          <img
            src="@/assets/images/xiaochengxu.jpg"
            class="imgs"
            title="小程序"
            alt="TikTok"
            style="border: 1px solid #000"
          />
          <p>微信小程序</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // askDialog:false
      languageDataObj: null
    }
  },
  created () {
    this.backLanguageText('officialWebsite')
  },
  watch: {
    language: function (val, oldVal) {
      this.backLanguageText('officialWebsite')
    }
  },
  methods: {
    backLanguageText (component) {
      this.languageDataObj = this.$language.changeLanguageType(
        this.language,
        component
      )
      // console.log('打印语言textoverview页面',this.languageDataObj)
    }
  },
  computed: {
    language () {
      return this.$store.state.languageType
    }
  }
}
</script>

<style lang="less" scoped>
a {
  text-decoration: none;
}
.wrapper {
  // max-width: 1172px;
  max-width: 1235px;
  overflow: hidden;
  height: 130px;
  max-height: 130px;
  padding: 150px 0 79px 20px;
  // background-color: pink;
  display: flex;
  margin: 0 auto;
  justify-content: space-between;

  .text-left {
    .text-item {
      display: flex;
      align-items: center;
      text-align: left;
      &.aligntop {
        align-items: flex-start;
      }
      .title {
        // width: 137px;
        width: 150px;
        // font-family: PingFangSC-Semibold;
        font-family: MicrosoftYaHei;
        font-size: 20px;
        color: #000000;
        font-weight: 800;
      }
      .list {
        display: flex;
        flex-wrap: wrap;
        min-width: 530px;
        // margin-left: 80px;
        margin-left: 30px;
        width: 700px;
        font-family: MicrosoftYaHeiLight;

        dd.item {
          min-width: 320px;
          // background-color: #c00;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          height: 28px;
          cursor: pointer;
          font-size: 15px;
          color: #000000;
          text-align: left;
          line-height: 28px;
          margin-top: 10px;
          &:nth-child(1),
          &:nth-child(2) {
            margin-top: 0;
          }
        }
        .lo {
          width: 28px;
          height: 28px;
          margin-left: 15px;
          cursor: pointer;
          background: no-repeat center center/cover;

          &:first-child {
            margin: 0;
          }
          &.lo1 {
            // color: aqua;
            background-image: url(@/assets/images/facebook.svg);
          }
          &.lo2 {
            // color: aqua;
            background-image: url(@/assets/images/twitter.svg);
          }
          &.lo3 {
            width: 30px;
            // color: aqua;
            background-image: url(@/assets/images/whatsapp.svg);
          }
        }
      }
      &:last-child {
        margin-top: 20px;
      }
    }
  }
  .qrcode-right {
    min-width: 80px;
    margin-left: 20px;
    display: flex;
    .qrcode {
      margin-left: 10px;
      p {
        font-size: 14px;
        margin-top: 10px;
      }
      &:first-child {
        margin-left: 0;
      }
      .imgs {
        width: 100px;
        height: 100px;
        // object-fit:contain;
      }
    }
    p {
      height: 26px;
      font-family: MicrosoftYaHei;
      font-size: 20px;
      color: #000000;
      margin-top: 24px;
      text-align: center;
      font-weight: 600;
    }
  }
}
</style>
